import { render, staticRenderFns } from "./FeatureExplanationModal.vue?vue&type=template&id=2e1c54fe"
import script from "./FeatureExplanationModal.vue?vue&type=script&lang=js"
export * from "./FeatureExplanationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports